import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

// action
import { removeLoading, addLoading } from '../../../commonAction'

const apiGetListNumOfSelfServeAuthNotSuccess = `${host}admin/exportJSON/kioskTransactionFailed`

export const getListNumOfSelfServeAuthNotSuccess = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListNumOfSelfServeAuthNotSuccess,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_NUM_OF_SELF_SERVE_NOT_SUCCESS,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_NUM_OF_SELF_SERVE_NOT_SUCCESS_ERROR,
            () => false
        )
    }
}

export const exportListNumOfSelfServeAuthNotSuccess = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListNumOfSelfServeAuthNotSuccess,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${BranchCodes.join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
